<template>
  <div class="weifare" v-loading="loading">
    <div class="weifare-first">
      <div class="weifare-first-top">
        <div class="weifare-first-top-left">每日爆品活动设置</div>
        <div class="weifare-first-top-right" @click="refresh">刷新</div>
      </div>

      <div class="weifare-first-table">
        <el-table
          :data="firstTable"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <el-table-column label="活动状态">
            <template slot-scope="">
              <div class="table-status">
                <el-switch
                  :value="activityStatus"
                  active-color="#13ce66"
                  inactive-color="#D9D9D9"
                  @change="weifareChange"
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="weifare-second">
      <div class="weifare-second-top">
        <div class="weifare-second-top-title">每日爆品商品列表</div>
        <div class="weifare-second-top-display">
          <div class="display-left">
            <div class="display-left-commodity">
              <div class="commodity-title">商品名称</div>
              <div class="commodity-input">
                <el-input
                  placeholder="请输入商品名称"
                  v-model="commodityName"
                  clearable
                >
                </el-input>
              </div>
            </div>

            <div class="display-left-hit">
              <div class="hit-query" @click="explosiveInquire">查询</div>
              <div class="hit-reset" @click="explosiveReset">重置</div>
            </div>
          </div>
          <div class="display-right" @click="addition">
            <img
              class="display-right-img"
              src="../../assets/common/common-add.png"
            />
            <div class="display-right-text">添加</div>
          </div>
        </div>
      </div>

      <div class="weifare-second-table">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <!-- 自定义暂无数据 -->
          <template slot="empty">
            <div class="empty-block">
              <img
                class="empty-block-img"
                src="../../assets/common/common-empty.png"
              />
              <div class="empty-block-text">暂无数据～</div>
            </div>
          </template>

          <el-table-column prop="name" label="商品名称"> </el-table-column>
          <el-table-column label="商品图片" width="234">
            <template slot-scope="scope">
              <img class="table-imgs" :src="scope.row.bombImage" alt="" />
            </template>
          </el-table-column>
          <el-table-column prop="bombPrice" label="优惠价(元)" width="200">
          </el-table-column>
          <el-table-column label="排序" width="180">
            <template slot-scope="scope">
              <div class="table-sort" @click="sortBtn(scope.row)">
                <!-- <img
                  class="table-sort-left"
                  :src="
                    scope.row.bombIndex == 1
                      ? require('../../assets/marketing/marketing-top.png')
                      : require('../../assets/marketing/marketing-no.png')
                  "
                  alt=""
                /> -->
                <img
                  class="table-sort-left"
                  src="../../assets/marketing/marketing-no.png"
                  alt=""
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <div class="operation">
                <!-- <div class="compile" @click="compileBtn(scope.row)">编辑</div> -->

                <div class="delete" @click="deleteBtn(scope.row)">删除</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="weifare-second-Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 第一区域  swicth 是否开启 -->
    <div class="switch">
      <el-dialog
        :visible.sync="switchDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="weifareCancel"
      >
        <span slot="footer" class="dialog-footer">
          <div class="switch-div">
            <img
              class="switch-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="switch-div-title">
              {{
                activityStatus == false
                  ? '是否开启此活动?'
                  : '请确定是否关闭此活动？'
              }}
            </div>
            <div class="switch-div-text">
              {{
                activityStatus == false
                  ? '一旦启用成功则用户可参与此活动。'
                  : '一旦成功关闭此活动，用户不可参与此项活动。'
              }}
            </div>
            <div class="switch-div-button">
              <div class="switch-div-button-left" @click="weifareConfirm">
                确定
              </div>
              <div class="switch-div-button-right" @click="weifareCancel">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--第二区域  添加-->
    <div class="addition">
      <el-dialog
        :visible.sync="additionDialogVisible"
        style="margin-top: 10vh"
        @close="additionReset"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="addition-div-top-title">商品添加</div>
              <img
                class="addition-div-top-img"
                src="../../assets/common/close.png"
                @click="additionReset"
              />
            </div>

            <div class="addition-div-center">
              <div class="addition-div-center-title">商品名称</div>
              <div class="addition-div-center-input">
                <el-autocomplete
                  class="inline-input"
                  v-model="suggestValue"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                  clearable
                ></el-autocomplete>
              </div>

              <div class="addition-div-center-display">
                <div class="display-left">
                  <div class="display-left-title">商品id</div>
                  <div class="display-left-select">
                    <el-input
                      placeholder="请输入商品id"
                      v-model="additioncommondityId"
                      class="input-with-select"
                      :disabled="true"
                    >
                    </el-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="addition-div-button">
              <!-- <div class="button-reset" @click="additionReset">重置</div> -->
              <div class="button-confirm" @click="additionConfirm">确定</div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--第二区域  商品编辑-->
    <!-- <div class="commodityedit">
      <el-dialog
        :visible.sync="editDialogVisible"
        style="margin-top: 10vh"
        @close="complitReset"
      >
        <span slot="footer" class="dialog-footer">
          <div class="commodityedit-div">
            <div class="commodityedit-div-top">
              <div class="commodityedit-div-top-title">编辑</div>
              <img
                class="commodityedit-div-top-img"
                src="../../assets/common/close.png"
                @click="complitReset"
              />
            </div>

            <div class="commodityedit-div-center">
              <div class="commodityedit-div-center-title">商品名称</div>
              <div class="commodityedit-div-center-input">
                <el-autocomplete
                  class="inline-input"
                  v-model="suggestValue"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                  clearable
                ></el-autocomplete>
              </div>

              <div class="commodityedit-div-center-display">
                <div class="display-left">
                  <div class="display-left-title">商品图片</div>
                  <div class="displat-left-img">
                    <el-upload
                      class="upload-img"
                      action="https://laravel-api-manager.xmw1688.com/common/upload"
                      list-type="picture-card"
                      :on-success="handleSuccess"
                      :limit="1"
                      :show-file-list="false"
                    >
                      <img
                        v-if="editcommondImage != ''"
                        class="avatar"
                        :src="editcommondImage"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../assets/common/common-uploadings.png"
                        class="avatar"
                      />
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>

            <div class="commodityedit-div-button">
              <div class="button-confirm" @click="complitConfirm">确定</div>
            </div>
          </div>
        </span></el-dialog
      >
    </div> -->

    <!--第二区域  商品删除-->
    <div class="commodityDetele">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        style="margin-top: 10vh"
        @close="deteleCancel"
      >
        <span slot="footer" class="dialog-footer">
          <div class="commodityDetele-div">
            <img
              class="commodityDetele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="commodityDetele-div-title">
              是否确定删除该活动商品？
            </div>
            <div class="commodityDetele-div-button">
              <div
                class="commodityDetele-div-button-left"
                @click="deteleConfirm"
              >
                确定
              </div>
              <div
                class="commodityDetele-div-button-right"
                @click="deteleCancel"
              >
                取消
              </div>
            </div>
          </div>
        </span></el-dialog
      >
    </div>
  </div>
</template>

<script>
import {
  geteverydayGoods,
  geteverydayGoodsrule,
  puteverydayDisable,
  deletefneveryday,
  puteverydayTop,
  posteverydayAdd,
} from '../../api/activities'

import { getMarketList } from '../../api/commodity'

export default {
  data() {
    return {
      /* 第一区域 */
      // 活动是否开启状态 false 关闭 true 开启
      activityStatus: false,
      // 表格
      firstTable: [],
      // 编辑 弹出框
      redactDialogVisible: false,
      // 编辑 弹出框 标题
      redactTitle: '',
      // 开始时间
      startTime: '',
      // 结束时间
      endTime: '',

      // 监听用户点击开关  弹出
      switchDialogVisible: false,
      switchTitleShow: false,
      /* end */

      /* 第二区域 */
      // 商品名称
      commodityName: '',
      // 表格区域
      tableData: [],

      // 添加弹出框  是否开启
      additionDialogVisible: false,
      // 添加弹出框  带建议搜索框数组
      restaurant: [],
      // 添加弹出框  带建议搜索框数组
      suggestValue: '',
      // 添加弹出框 选中
      additioncommondityId: '',
      // 添加弹出框 获取模糊搜索中的商品信息
      additionObj: {},
      // 添加或者编辑 图片
      additionImage: '',
      // 商品编辑弹出框模块

      // 商品编辑弹出框 是否开启
      editDialogVisible: false,
      // 商品编辑弹出框 id
      editcommondId: '',
      // 商品编辑弹出框 商品名称
      editcommondName: '',
      // 商品编辑弹出框 图片保存
      editcommondImage: '',
      // 商品编辑弹出框 获取模糊搜索中的商品信息
      editObj: {},
      // 商品编辑弹出框 金额
      editPrice: '',

      // 删除弹出框开启
      deteleDialogVisible: false,
      // 监听用户刷新
      loading: false,
      // 页码
      page: 1,
      // 条数
      limit: 10,
      // 总条数
      totalNum: 0,
      // 当前商品删除选中id
      deteleId: '',
      // 控制当前页面功能性按钮开关
      activeiesFunShow: false,
    }
  },
  created() {
    // 获取每日爆品基本数据
    this.loading = true
    this.geteveryday()

    setTimeout(() => {
        this.activeiesFunShow = this.$store.state.pageFunctionShow
    }, 1000);
  },
  methods: {
    // 获取每日爆品基本数据
    geteveryday() {
      let params = {
        goodsName: this.commodityName, // 商品名称
        pageSize: this.limit, // 页码
        pageNo: this.page, // 页数
      }

      geteverydayGoods(params).then((res) => {
        console.log('获取每日爆品', res)
        if (res.resultStatus == true) {
          let Obj = res.resultData
          this.activityStatus = Obj.status == 0 ? false : true
          // 获取第一区域表格数据
          this.firstTable = []
          this.firstTable.push(Obj)
          // 获取第二区域表格数据
          this.tableData = Obj.bombList
          // 获取列表总数
          this.totalNum = Obj.totalNum
          this.loading = false
        }
      })
    },
    // 第一区域 点击是否开启活动按钮 弹窗开启
    weifareChange() {
      if (this.activeiesFunShow == false) {
        return
      }

      this.switchDialogVisible = true
    },
    // 第一区域 点击是否开启活动按钮 弹窗开启  确定
    weifareConfirm() {
      if (this.totalNum > 0) {
        let params = {}
        // 切换是否开启或者禁用
        puteverydayDisable(params).then((res) => {
          if (res.resultStatus == true) {
            this.$message({
              message: this.activityStatus == false ? '启动成功' : '禁用成功',
              type: 'success',
            })

            this.activityStatus = !this.activityStatus
            this.switchDialogVisible = false
            this.geteveryday()
          }
        })
      } else {
         this.$message({
              message: '开启活动必须有一件商品！',
              type: 'success',
            })
        this.switchDialogVisible = false
      }
    },
    // 第一区域 点击是否开启活动按钮 弹窗开启  取消
    weifareCancel() {
      this.switchDialogVisible = false
    },
    /*end */

    /* 第二区域 */
    // 添加  开启弹出框
    addition() {
      if (this.activeiesFunShow == false) {
        return
      }

      this.additionDialogVisible = true
    },
    // 添加 带建议搜索
    // 供应商带建议搜索
    querySearch(queryString, cb) {
      if (queryString == '') {
        cb(this.restaurant)
      } else {
        let params = {
          id: '', // 商品id
          name: this.suggestValue, // 商品名称
          code: '', // 商品编号
          chandi: '', // 产地
          is_speciality: '', // 是否为特产  1是
          is_handpick: '', // 是否精选 1是
          goods_one_type_id: '', // 一级分类id
          goods_two_type_id: '', // 二级分类id
          supplier_name: '', // 供应商名称
          brand_name: '', // 品牌名称
          status: 2, // 状态:1=上架,2=下架 30活动中
          pageSize: 99999999, // 页码
          pageNo: 1, // 页数
        }

        getMarketList(params, { condition: queryString }).then((res) => {
          if (res.resultStatus == true) {
            this.restaurant = res.resultData.goodsList
            //这个插件只能过滤key为value得值.所以要把获取到得后台字段给重新赋值为value
            res.resultData.goodsList.map((item) => {
              item.value = item.name
              return item
            })

            cb(res.resultData.goodsList)
          }
        })
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    loadAll() {
      return this.restaurant
    },
    handleSelect(item) {
      // 添加
      this.additioncommondityId = item.id
      this.additionImage = item.image
      this.additionObj = item

      // 编辑
      this.editcommondId = item.id
      this.editcommondImage = item.image
      this.editPrice = item.vip_price
      this.editObj = item
    },

    /***end */
    // 添加 重置 取消按钮
    additionReset() {
      this.additioncommondityId = ''
      this.additionImage = ''
      this.suggestValue = ''
      this.additionObj = {}
      this.additionDialogVisible = false
    },
    // 添加 确定 确认按钮
    additionConfirm() {
      console.log('确认添加信息', this.additionObj)
      // 添加商品的时候确认添加
      let params = {
        id: this.additioncommondityId,
        bombImage: this.additionObj.image,
        bombPrice: this.additionObj.vip_price,
      }

      posteverydayAdd(params).then((res) => {
        console.log('获取添加数据', res)
        if (res.resultStatus == true) {
          this.loading = true
          this.$message({
            message: '添加成功！',
            type: 'success',
          })
          this.geteveryday()
          this.additionDialogVisible = false
        } else {
          this.additionDialogVisible = false
        }
      })
    },
    // end
    // 商品区域 编辑 弹出框模块
    compileBtn(item) {
      if (this.activeiesFunShow == false) {
        return
      }

      console.log('点击 编辑', item)
      this.editcommondId = item.id // id
      this.suggestValue = item.name
      this.editcommondImage = item.bombImage
      this.editPrice = item.bombPrice
      this.editDialogVisible = true
    },
    // 商品区域 编辑 重置
    complitReset() {
      this.editcommondId = ''
      this.suggestValue = ''
      this.editcommondImage = ''
      this.editPrice = ''
      this.editObj = {}
      this.editDialogVisible = false
    },
    // 查询
    explosiveInquire() {
      this.geteveryday()
    },
    // 重置
    explosiveReset() {
      this.commodityName = ''
      this.geteveryday()
    },

    // 第二区域点击 删除弹出框
    deleteBtn(item) {
      if (this.activeiesFunShow == false) {
        return
      }

      this.deteleId = item.id
      this.deteleDialogVisible = true
    },

    // 商品区域  删除弹出框确认
    deteleConfirm() {
      // 活动开启状态 必须保留一个商品
      console.log('活动开启', this.activityStatus)
      // 活动关闭状态 所有商品都可以删除

      if (this.activityStatus == true) {
        if (this.totalNum > 1) {
          let params = this.deteleId
          deletefneveryday(params).then((res) => {
            if (res.resultStatus == true) {
              this.loading = true
              this.$message({
                message: '删除成功',
                type: 'success',
              })
              this.geteveryday()
              this.deteleDialogVisible = false
            }
          })
        } else {
          this.$message({
            message: '活动开启状态必须保留一件商品！ ',
            type: 'error',
          })

          this.deteleDialogVisible = false
        }
      } else {
        let params = this.deteleId
        deletefneveryday(params).then((res) => {
          if (res.resultStatus == true) {
            this.loading = true
            this.$message({
              message: '删除成功',
              type: 'success',
            })
            this.geteveryday()
            this.deteleDialogVisible = false
          }
        })
      }
    },

    // 删除弹出框 中 取消
    deteleCancel() {
      this.deteleId = ''
      this.deteleDialogVisible = false
    },

    // 查询当前页码多少条
    handleSizeChange(val) {
      this.limit = val
      this.loading = true
      console.log(`每页 ${val} 条`)
      this.geteveryday()
    },
    // 查询当前页
    handleCurrentChange(val) {
      this.page = val
      this.loading = true
      console.log(`当前页: ${val}`)
      this.geteveryday()
    },
    // 用户点击界面刷新
    refresh() {
      this.loading = true

      this.$nextTick(() => {
        this.geteveryday()
      })
    },
    // 上传成功
    handleSuccess(file, fileList) {
      this.editcommondImage = file.resultData
    },
    masterDetele() {
      this.editcommondImage = ''
    },
    // 商品区域 排序
    sortBtn(item) {
      if (this.activeiesFunShow == false) {
        return
      }
      console.log(item)
      let params = item.id
      puteverydayTop(params).then((res) => {
        console.log('获取对应的额params', res)
        if (res.resultStatus == true) {
          this.loading = true
          this.$message({
            message: '置顶成功',
            type: 'success',
          })
          this.geteveryday()
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.weifare {
  .weifare-first {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    padding-bottom: 24px;
    box-sizing: border-box;
    .weifare-first-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 68px;

      .weifare-first-top-left {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .weifare-first-top-right {
        width: 70px;
        height: 36px;
        border-radius: 10px;
        border: 1px solid rgba(34, 34, 34, 0.4);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
      }
    }

    .weifare-first-table {
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      .table-rule {
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .table-status {
        width: 42px;
        height: 25px;
        /deep/ .el-switch__core {
          width: 42px !important;
        }
      }
    }
  }

  .weifare-second {
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px #edeff7;
    border-radius: 10px;
    padding: 0 24px;
    box-sizing: border-box;
    margin-top: 24px;
    .weifare-second-top {
      height: 146px;

      .weifare-second-top-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
        height: 68px;
        line-height: 68px;
      }

      .weifare-second-top-display {
        display: flex;
        justify-content: space-between;
        align-items: self-end;

        .display-left {
          display: flex;
          align-items: self-end;
          .display-left-commodity {
            .commodity-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .commodity-input {
              margin-top: 4px;
              width: 330px;

              /deep/ .el-input {
                height: 32px;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }
            }
          }

          .display-left-hit {
            display: flex;
            margin-left: 40px;

            .hit-query,
            .hit-reset {
              width: 110px;
              height: 36px;
              background: #222222;
              border-radius: 10px;
              text-align: center;
              line-height: 36px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              cursor: pointer;
            }

            .hit-reset {
              background: #f4f5f9;
              margin-left: 10px;
              color: #999999;
            }
          }
        }

        .display-right {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 82px;
          height: 36px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          cursor: pointer;
          .display-right-img {
            width: 13px;
            height: 13px;
          }

          .display-right-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            margin-left: 8px;
          }
        }
      }
    }

    .weifare-second-table {
      /deep/ .el-table .el-table__cell {
        padding: 13px 0;
        vertical-align: top;
      }
      /deep/ .el-table thead {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        background: #d8d8d8;
      }

      /deep/ .el-table tr {
        height: 46px;
      }

      /deep/ .el-table__empty-text {
        line-height: 0;
      }

      .empty-block {
        margin-top: 62px;
        padding-bottom: 40px;
        .empty-block-img {
          width: 130px;
          height: 130px;
          margin: 0 auto;
        }

        .empty-block-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          height: 17px;
          line-height: 17px;
        }
      }

      .table-imgs {
        width: 120px;
        height: 70px;
      }

      .table-sort {
        display: flex;

        .table-sort-left,
        .table-sort-right {
          width: 23px;
          height: 23px;
        }

        .table-sort-right {
          margin-left: 4px;
        }
      }

      .operation {
        display: flex;

        .compile,
        .delete {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2aa4ff;
          text-decoration: underline;
        }

        // .delete {
        //   margin-left: 24px;
        // }
      }
    }

    .weifare-second-Pagination {
      height: 88px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .el-pagination .btn-prev {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        margin-right: 8px;
      }

      /deep/ .el-pagination .btn-next {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
      }

      /deep/ .el-pager li {
        padding: 0;
        width: 32px;
        height: 32px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #d9d9d9;
        line-height: 32px;
        margin-right: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }

      /deep/ .el-pager li.active {
        background: #000000;
        color: #ffffff;
      }

      /deep/ .el-input--mini .el-input__inner {
        height: 32px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  /* 弹出框 */
  .switch {
    /deep/ .el-dialog {
      height: 231px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .switch-div {
      width: 100%;
      text-align: center;
      .switch-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .switch-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-top: 8px;
      }

      .switch-div-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 2px;
      }

      .switch-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 18px;

        .switch-div-button-left,
        .switch-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .switch-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }

  /* 添加弹出框 */
  .addition {
    /deep/ .el-dialog {
      width: 444px;
      height: 280px;
      background: #ffffff;
      box-shadow: 0px 12px 48px 16px rrgba(134, 77, 77, 0.03) 0px 9px 28px 0px
          rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }

    .addition-div {
      .addition-div-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        .addition-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .addition-div-top-img {
          width: 10px;
          height: 10px;
        }
      }

      .addition-div-center {
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 20px;
        .addition-div-center-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .addition-div-center-input {
          margin-top: 4px;
          width: 100%;
          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-autocomplete {
            width: 100%;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }
        }

        .addition-div-center-display {
          display: flex;
          margin-top: 14px;

          .display-left {
            width: 100%;
            .display-left-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .display-left-select {
              margin-top: 4px;
              width: 100%;
              height: 32px;
              /deep/ .el-input {
                height: 32px;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }
            }
          }
        }
      }

      .addition-div-button {
        margin-top: 24px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 16px;
        box-sizing: border-box;
        border-top: 1px solid #d9d9d9;

        .button-reset,
        .button-confirm {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .button-confirm {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }

  /* 商品编辑 */
  .commodityedit {
    /deep/ .el-dialog {
      width: 444px;
      height: 352px;
      background: #ffffff;
      box-shadow: 0px 12px 48px 16px rrgba(134, 77, 77, 0.03) 0px 9px 28px 0px
          rgba(0, 0, 0, 0.05),
        0px 6px 16px -8px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
    }

    /deep/ .el-dialog__footer {
      padding: 0;
      text-align: left;
    }

    .commodityedit-div {
      .commodityedit-div-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 56px;
        padding: 0 24px;
        box-sizing: border-box;
        border-bottom: 1px solid #d9d9d9;
        .commodityedit-div-top-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #222222;
        }

        .commodityedit-div-top-img {
          width: 10px;
          height: 10px;
        }
      }

      .commodityedit-div-center {
        padding: 0 24px;
        box-sizing: border-box;
        margin-top: 20px;
        .commodityedit-div-center-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .commodityedit-div-center-input {
          margin-top: 4px;
          width: 100%;
          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }

          /deep/ .el-autocomplete {
            width: 100%;
          }
        }

        .commodityedit-div-center-display {
          margin-top: 14px;
          display: flex;
          .display-left {
            .display-left-title {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .displat-left-img {
              width: 100px;
              height: 100px;
              margin-top: 8px;
              position: relative;
              cursor: pointer;

              .upload-img {
                width: 100px;
                height: 100px;
                position: relative;

                /deep/ .el-upload--picture-card {
                  width: 100px;
                  height: 100px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border: 1px solid rgba(255, 255, 255, 0);
                }

                /deep/ .el-upload--picture-card:hover {
                  border-color: rgba(255, 255, 255, 0);
                }

                /deep/ .el-upload-list--picture-card .el-upload-list__item {
                  width: 100px;
                  height: 100px;
                  margin: 0;
                }
                .avatar {
                  width: 100px;
                  height: 100px;
                }

                .detele {
                  position: absolute;
                  top: -10px;
                  right: -10px;
                  width: 20px;
                  height: 20px;
                }
              }
            }
          }

          .display-right {
            margin-left: 58px;
            .display-right-lintprize {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .display-right-input {
              width: 100%;
              margin-top: 4px;
              /deep/ .el-input {
                height: 32px;
              }

              /deep/ .el-input__inner {
                padding: 0 10px;
                box-sizing: border-box;
                height: 32px;
                background-color: rgba(255, 255, 255, 0);
              }

              /deep/ .el-input-group__append {
                background-color: #ffffff;
                height: 32px;
                padding: 0;
              }
              .input-append {
                width: 38px;
                height: 30px;
                background: #ffffff;
                border-radius: 0px 5px 5px 0px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #555555;
              }
            }
          }
        }
      }
      .commodityedit-div-button {
        margin-top: 24px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 16px;
        box-sizing: border-box;
        border-top: 1px solid #d9d9d9;

        .button-reset,
        .button-confirm {
          width: 65px;
          height: 32px;
          background: #ffffff;
          border-radius: 10px;
          border: 1px solid #e9edf4;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #555555;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }

        .button-confirm {
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          color: #ffffff;
          margin-left: 8px;
        }
      }
    }
  }

  /* 商品删除 */
  .commodityDetele {
    /deep/ .el-dialog {
      height: 231px;
      width: 394px;
    }

    /deep/ .el-dialog__footer {
      padding: 25px 0;
      box-sizing: border-box;
    }

    .commodityDetele-div {
      width: 100%;
      text-align: center;
      .commodityDetele-div-img {
        width: 56px;
        height: 56px;
        margin: 0 auto;
      }

      .commodityDetele-div-title {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-top: 8px;
      }

      .commodityDetele-div-button {
        display: flex;
        justify-content: center;
        align-content: center;
        margin-top: 40px;

        .commodityDetele-div-button-left,
        .commodityDetele-div-button-right {
          width: 88px;
          height: 32px;
          background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
          border-radius: 10px;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }

        .commodityDetele-div-button-right {
          margin-left: 8px;
          border: 1px solid #e9edf4;
          color: rgba(0, 0, 0, 0.65);
          background: #ffffff;
        }
      }
    }
  }
}
</style>
